// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  background: linear-gradient(160deg, #2C1A06 0%, #1A0E04 100%);
  color: rgba(255, 255, 255, 0.8);
  margin-top: auto;
}

.footer-top {
  padding: 64px 0 40px;
}

.footer-grid {
  display: grid;
  grid-template-columns: 1.8fr 1fr 1fr 1fr;
  gap: 48px;
}

.footer-logo {
  margin-bottom: 16px;
}

.footer-logo-img {
  height: 100px;
  width: auto;
  object-fit: contain;
}

.footer-tagline {
  font-size: 0.88rem;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 20px;
}

.footer-social {
  display: flex;
  gap: 10px;
}

.social-btn {
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(200, 134, 10, 0.15);
  border: 1px solid rgba(200, 134, 10, 0.25);
  border-radius: 10px;
  color: rgba(255, 255, 255, 0.65);
  transition: all 0.2s ease;
  cursor: pointer;
}

.social-btn svg {
  width: 17px;
  height: 17px;
  flex-shrink: 0;
}

.social-btn:hover {
  background: rgba(200, 134, 10, 0.35);
  color: var(--white);
  transform: translateY(-2px);
}

.footer-col h4 {
  font-size: 1rem;
  font-weight: 600;
  color: var(--gold-light);
  margin-bottom: 16px;
  font-family: 'Poppins', sans-serif;
}

.footer-col ul {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.footer-col ul li a {
  font-size: 0.88rem;
  color: rgba(255, 255, 255, 0.6);
  transition: color 0.2s ease;
}

.footer-col ul li a:hover {
  color: var(--gold-light);
}

.footer-contact li {
  font-size: 0.88rem;
  color: rgba(255, 255, 255, 0.6);
}

.footer-bottom {
  border-top: 1px solid rgba(200, 134, 10, 0.2);
  padding: 18px 0;
}

.footer-bottom-inner {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 16px;
}

.footer-copy {
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.35);
}

.footer-faith {
  font-size: 0.88rem;
  color: var(--gold) !important;
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
}

.footer-dev {
  font-size: 0.78rem;
  color: rgba(255, 255, 255, 0.3);
  text-align: right;
}

.footer-dev a {
  color: rgba(200, 134, 10, 0.7);
  font-weight: 500;
  transition: color 0.2s ease;
  white-space: nowrap;
}

.footer-dev a:hover {
  color: var(--gold-light);
}

@media (max-width: 560px) {
  .footer-bottom-inner {
    grid-template-columns: 1fr;
    text-align: center;
    gap: 6px;
  }

  .footer-dev {
    text-align: center;
  }
}

@media (max-width: 900px) {
  .footer-grid {
    grid-template-columns: 1fr 1fr;
    gap: 32px;
  }

  .footer-brand {
    grid-column: 1 / -1;
  }
}

@media (max-width: 560px) {
  .footer-grid {
    grid-template-columns: 1fr;
  }

  .footer-bottom-inner {
    flex-direction: column;
    gap: 8px;
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer.css"],"names":[],"mappings":"AAAA;EACE,6DAA6D;EAC7D,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,gCAAgC;EAChC,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,6CAA6C;EAC7C,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,0BAA0B;IAC1B,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;EACpB;AACF","sourcesContent":[".footer {\n  background: linear-gradient(160deg, #2C1A06 0%, #1A0E04 100%);\n  color: rgba(255, 255, 255, 0.8);\n  margin-top: auto;\n}\n\n.footer-top {\n  padding: 64px 0 40px;\n}\n\n.footer-grid {\n  display: grid;\n  grid-template-columns: 1.8fr 1fr 1fr 1fr;\n  gap: 48px;\n}\n\n.footer-logo {\n  margin-bottom: 16px;\n}\n\n.footer-logo-img {\n  height: 100px;\n  width: auto;\n  object-fit: contain;\n}\n\n.footer-tagline {\n  font-size: 0.88rem;\n  line-height: 1.7;\n  color: rgba(255, 255, 255, 0.6);\n  margin-bottom: 20px;\n}\n\n.footer-social {\n  display: flex;\n  gap: 10px;\n}\n\n.social-btn {\n  width: 38px;\n  height: 38px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(200, 134, 10, 0.15);\n  border: 1px solid rgba(200, 134, 10, 0.25);\n  border-radius: 10px;\n  color: rgba(255, 255, 255, 0.65);\n  transition: all 0.2s ease;\n  cursor: pointer;\n}\n\n.social-btn svg {\n  width: 17px;\n  height: 17px;\n  flex-shrink: 0;\n}\n\n.social-btn:hover {\n  background: rgba(200, 134, 10, 0.35);\n  color: var(--white);\n  transform: translateY(-2px);\n}\n\n.footer-col h4 {\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--gold-light);\n  margin-bottom: 16px;\n  font-family: 'Poppins', sans-serif;\n}\n\n.footer-col ul {\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.footer-col ul li a {\n  font-size: 0.88rem;\n  color: rgba(255, 255, 255, 0.6);\n  transition: color 0.2s ease;\n}\n\n.footer-col ul li a:hover {\n  color: var(--gold-light);\n}\n\n.footer-contact li {\n  font-size: 0.88rem;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.footer-bottom {\n  border-top: 1px solid rgba(200, 134, 10, 0.2);\n  padding: 18px 0;\n}\n\n.footer-bottom-inner {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  align-items: center;\n  gap: 16px;\n}\n\n.footer-copy {\n  font-size: 0.8rem;\n  color: rgba(255, 255, 255, 0.35);\n}\n\n.footer-faith {\n  font-size: 0.88rem;\n  color: var(--gold) !important;\n  font-weight: 600;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.footer-dev {\n  font-size: 0.78rem;\n  color: rgba(255, 255, 255, 0.3);\n  text-align: right;\n}\n\n.footer-dev a {\n  color: rgba(200, 134, 10, 0.7);\n  font-weight: 500;\n  transition: color 0.2s ease;\n  white-space: nowrap;\n}\n\n.footer-dev a:hover {\n  color: var(--gold-light);\n}\n\n@media (max-width: 560px) {\n  .footer-bottom-inner {\n    grid-template-columns: 1fr;\n    text-align: center;\n    gap: 6px;\n  }\n\n  .footer-dev {\n    text-align: center;\n  }\n}\n\n@media (max-width: 900px) {\n  .footer-grid {\n    grid-template-columns: 1fr 1fr;\n    gap: 32px;\n  }\n\n  .footer-brand {\n    grid-column: 1 / -1;\n  }\n}\n\n@media (max-width: 560px) {\n  .footer-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .footer-bottom-inner {\n    flex-direction: column;\n    gap: 8px;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
